
import Vue from 'vue'
import Router from 'vue-router'

const ResultsGroup = () => import(/* webpackChunkName: "ResultsGroup" */ '../views/Search/ResultsGroup')
const Result = () => import(/* webpackChunkName: "Result" */ '../views/Search/Result')
const ResultsV2 = () => import(/* webpackChunkName: "ResultsGroupV2" */'../views/Search/ResultsGroupV2')

// We should import store in bottom of components, because route using component and we need use store for auth
import store from '@/store'

Vue.use(Router)

const searchRouter = [
    {
      path: '/results/group',
      name: 'resultsgroup',
      component: ResultsGroup
    },
    {
      path: '/results/',
      name: 'resultsgroupV2',
      component: ResultsV2
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
]

export default searchRouter;
